module.exports = __webpack_public_path__ + "img/commerce.3b186586.jpg";